import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Toggler from 'hoc/toggler'
import Divider from 'components/shared/divider/horizontal'
import ScheduleTourHandler from 'components/shared/modals/handlers/schedule-tour'
import MessageSpaceOwnerHandler from 'components/shared/modals/handlers/message-space-owner'
import MoreSpaceOptions from 'components/shared/options/more-spaces'
import isEmpty from 'lodash/isEmpty'
import Modalhandler from 'components/shared/modal/modal-handler'
import Actions from '../include/actions'
import MoreSpacesSelection from '../selections/more-spaces'

const InquireCommon = ({
  preSelectedSpace,
  title,
  spaces,
  place,
  toggle,
  isOpen,
  showOption = true,
}) => {
  const [selectedSpace, setSelectedSpace] = useState(spaces[0])

  useEffect(() => {
    !isEmpty(preSelectedSpace) && setSelectedSpace(preSelectedSpace)
  }, [preSelectedSpace])

  const renderInquire = () => (
    <div className="inquire sticky-header w-full fixed bottom-0 right-0 left-0 bg-white lg:bg-transparent z-20 mx-auto lg:sticky lg:pl-15px">
      <div className="border-t-2 lg:border lg:rounded-lg border-secondary-graywhite">
        <div className="flex flex-col w-full mx-auto">
          <div className="flex flex-col justify-around hover:bg-orange-100 px-4 py-1 lg:px-6 lg:py-4 xl:px-8 xl:py-6">
            <div className="flex flex-row justify-between items-center relative">
              <h4 className="text-lg pr-2">{selectedSpace.title}</h4>
              {showOption && (
                <span className="hidden md:block cursor-pointer" onClick={toggle}>
                  <i
                    className={`text-2xl fa ${isOpen ? 'fa-angle-up' : 'fa-angle-down'}`}
                    aria-hidden="true"
                  ></i>
                </span>
              )}
              {showOption && (
                <Modalhandler
                  className="w-max md:hidden"
                  title={
                    <span className="cursor-pointer">
                      <i className={`text-2xl fa fa-angle-down`} aria-hidden="true"></i>
                    </span>
                  }
                >
                  {({ toggle: onClose }) => (
                    <MoreSpacesSelection
                      spaces={spaces}
                      selected={selectedSpace}
                      selectSpace={setSelectedSpace}
                      onClose={onClose}
                    />
                  )}
                </Modalhandler>
              )}
              {isOpen && (
                <MoreSpaceOptions
                  onClose={toggle}
                  spaces={spaces}
                  selected={selectedSpace}
                  selectSpace={setSelectedSpace}
                />
              )}
            </div>
            <div className="inquire-info flex flex-row justify-around lg:justify-start text-primary-lightgray">
              <div className="flex-1 lg:flex-1 md:flex-1 whitespace-no-wrap overflow-hidden">
                <p className="text-sm pt-1">
                  <i className="fa fa-user mr-2" aria-hidden="true"></i>
                  {selectedSpace.capacity}
                </p>
                <span className="text-sm text-primary-black pt-1">
                  {selectedSpace.prices.map((price) => `${price.amount}/${price.type}`).join(', ')}
                </span>
              </div>
            </div>
          </div>
          <div className="p-0 lg:px-6 xl:px-8">
            <Divider className="mb-5 hidden lg:block" />
            <div className="lg:flex-grow lg:block flex text-center flex-row-reverse gap-1 px-3 lg:gap-0 lg:px-0">
              <ScheduleTourHandler
                title={title}
                spaces={spaces}
                place={place}
                selectedSpace={selectedSpace}
              />
              <p className="text-primary-lightgray mt-2 text-xs hidden lg:block">
                Booking is Free and No Commitment!
              </p>
              <MessageSpaceOwnerHandler
                className="btn bg-white w-full border border-primary-orange text-primary-orange lato-bold py-3 lg:my-6 cursor-pointer"
                title={title}
                spaces={spaces}
                place={place}
                selectedSpace={selectedSpace}
              />
            </div>
          </div>
        </div>
      </div>
      <Actions id={selectedSpace.id} />
    </div>
  )

  return selectedSpace && renderInquire()
}

InquireCommon.propTypes = {
  title: PropTypes.string,
  capacity: PropTypes.string,
  prices: PropTypes.array,
  spaces: PropTypes.array,
  place: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  showOption: PropTypes.bool,
}

const mapStateToProps = ({ space }) => ({
  preSelectedSpace: space.spaceInfo || {}, // checks if the user is currently on the space page via checking the reducer
})

export default Toggler(connect(mapStateToProps)(InquireCommon), { canceledOnTouchOutside: false })
